import * as React from 'react'
import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

export const TitleAndText = ({ slice }) => {
  const {title, text} = slice.primary

  return (
    <div className="bg-white text-dark py-80px">
      <div className="container">
        {title && <h2 className="text-center text-primary mb-4">{title}</h2>}
        <div className="">
          <PrismicRichText field={text.richText} />
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  fragment HomepageDataBodyTitleAndText on PrismicHomepageDataBodyTitleAndText {
    primary {
      title
      text {
        richText
      }
    }
  }
  fragment PageDataBodyTitleAndText on PrismicPageDataBodyTitleAndText {
    primary {
      title
      text {
        richText
      }
    }
  }
  fragment MenuDataBodyTitleAndText on PrismicMenuDataBodyTitleAndText {
    primary {
      title
      text {
        richText
      }
    }
  }
`
